import { useContext } from 'react';
import { OptimizelyContext } from 'lib/optimizely/optimizely';
import { OptimizelyContextValue } from 'lib/optimizely/optimizely.types';

interface Result {
  isTripadvisorModal: boolean;
  ignoredList: Array<number>;
}

const FEATURE_FLAG_NAME = 'qantas-hotels-tripadvisor-modal';

const useTripadvisorModal = (): Result => {
  const optimizelyContext = useContext(OptimizelyContext) as OptimizelyContextValue;
  const decision = optimizelyContext?.decisions?.[FEATURE_FLAG_NAME];

  const { enabled = false } = decision || {};
  const isReady = optimizelyContext?.isReady ?? false;

  if (!isReady) {
    return {
      isTripadvisorModal: false,
      ignoredList: [],
    };
  }

  return {
    isTripadvisorModal: enabled,
    ignoredList: decision?.variables?.ignoredList || [],
  };
};

export default useTripadvisorModal;
